export const TOKEN_KEY = 'wems_crm_token';
export const REFRESH_TOKEN_KEY = 'wems_crm_refresh_token';
export const USER_KEY = 'wems_crm_user';
export const PERMISSIONS_KEY = 'wems_crm_permissions';

const legacyKeys = [TOKEN_KEY, REFRESH_TOKEN_KEY, USER_KEY, PERMISSIONS_KEY];

/** Remove credentials and identity caches created by the retired browser-token flow. */
export function clearAuthTokens(): void {
  for (const key of legacyKeys) {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  }
}
